import React from 'react';

const About = () => {
  return (
    <div className="about-page" style={{backgroundColor: 'var(--bg-dark)'}}>
      <div className="page-header" style={{backgroundImage: "url('https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80')"}}>
        <div className="page-header-overlay"></div>
        <div className="container page-header-content">
          <h1 className="fw-bold">About Us</h1>
          <p className="description">Your Trusted Partner in the Heart of Nevis</p>
        </div>
      </div>

      <div className="container py-5">
        <div className="row align-items-center mb-5">
          <div className="col-lg-8 mx-auto text-center">
             <h2 className="text-white fw-bold mb-4" style={{fontFamily: 'var(--font-serif)'}}>Integrity, Privacy, Excellence</h2>
             <p className="lead mb-4">
               Nevis Trust Services Limited was established with a singular focus: to provide impeccable corporate and fiduciary services within the Federation of St. Kitts and Nevis.
             </p>
             <p className="text-muted">
               We understand that in today's global economy, flexibility and security are paramount. Our team comprises seasoned legal and financial professionals with deep expertise in Nevis law. We act not just as service providers, but as guardians of your interests, ensuring that every structure we create—be it a Trust, an LLC, or an IBC—is robust, compliant, and tailored to your specific objectives.
             </p>
          </div>
        </div>

        <div className="row g-4 mt-4">
          <div className="col-md-4">
            <div className="card border-0 h-100 p-4">
              <div className="card-body text-center">
                <div className="mb-4 text-accent">
                  <i className="bi bi-award fs-1"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: 'var(--font-serif)'}}>Expert Knowledge</h4>
                <p className="card-text text-muted small mt-3">
                  Deep understanding of the Nevis Business Corporation Ordinance and International Exempt Trust Ordinance.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 h-100 p-4">
              <div className="card-body text-center">
                <div className="mb-4 text-accent">
                  <i className="bi bi-lock fs-1"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: 'var(--font-serif)'}}>Strict Confidentiality</h4>
                <p className="card-text text-muted small mt-3">
                  We adhere to the highest standards of client privacy and data security, a hallmark of the Nevis jurisdiction.
                </p>
              </div>
            </div>
          </div>
           <div className="col-md-4">
            <div className="card border-0 h-100 p-4">
              <div className="card-body text-center">
                <div className="mb-4 text-accent">
                  <i className="bi bi-globe fs-1"></i>
                </div>
                <h4 className="card-title fw-bold text-white" style={{fontFamily: 'var(--font-serif)'}}>Global Reach</h4>
                <p className="card-text text-muted small mt-3">
                  Serving international clients from Europe, Asia, and the Americas with seamless communication and support.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
